/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { Tooltip } from '@mantine/core';
import isNil from 'lodash/isNil';

// Utils
import { truncateString } from '@utils/functions';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const CellShortText = (props: {
	text: string;
}) => {
	const { text } = props;
	return (
		<Tooltip
			disabled={!isNil(text) && text.length <= 23}
			label={text}
		>
			<span>{truncateString(text, 23)}</span>
		</Tooltip>
	);
};
